module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/7JPAq0ct4Z2V6PzvMnkzXG-8a48f23f70813b62ca36da759758300b.jpg";